import { NgModule, Type } from '@angular/core';
import { RouterModule } from '@angular/router';
import {
  NgbDatepickerModule,
  NgbNavModule,
  NgbTooltipModule,
} from '@ng-bootstrap/ng-bootstrap';
import { SharedModule } from 'src/app/shared/shared.module';

const sharedMComponents: any[] | Type<any> = [];
const ngBootstrapModules: any[] | Type<any> = [
  NgbDatepickerModule,
  NgbNavModule,
  NgbTooltipModule,
];
const sharedModules: any[] | Type<any> = [SharedModule, ngBootstrapModules];
@NgModule({
  declarations: [sharedMComponents],
  imports: [RouterModule, sharedModules],
  exports: [sharedMComponents, sharedModules],
})
export class SharedProfileModule {}
